import { addPartnerFiles } from "api/Partners";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useAddPartnerFiles = () => {
    const queryClient = useQueryClient();
    return useMutation(addPartnerFiles, {
        onSuccess: () => {
            queryClient.invalidateQueries('partners');
            toast.success("Products added successfully");
        },
        onError: () => {
            toast.error(`Something went wrong`);
        },
    });
};
